<template>
  <page :basic="true">
    <span slot="header">Topics</span>
    <template slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
      <template v-if="role === 'owner' || role === 'master' || role ==='admin'">
        <div>
          <router-link :to="{name: 'admin-topics'}">
            <i class="fas fa-exchange-alt"></i> Switch to Admin View
          </router-link>
        </div>
      </template>
      <template v-if="role !== 'owner'">
        <div>
          <router-link :to="{name: 'starred-topics'}">
            <i class="fas fa-star"></i> Your Starred Topics
          </router-link>
        </div>
      </template>
    </template>
    <topics-table :view="view"/>
  </page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import topicsTable from './table'
import page from '../../../templates/page'

export default {
  components: {
    topicsTable,
    page
  },
  data () {
    return {
      breadcrumbs: [{
        text: 'Modules',
        to: { name: 'client-modules' }
      },
      {
        text: 'Components',
        to: { name: 'client-components' }
      },
      {
        text: 'Topics',
        active: true
      }]
    }
  },
  computed: {
    ...mapState('topics', {
      view: '_clientView'
    }),
    ...mapGetters('client', {
      role: 'getCurrentRole'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/client/topics/index.vue